import { Prerequisite } from "@/features/adp/services/common/common.types";

export const LOAD_TYPE_PREREQUISITES: Prerequisite = {
    title: 'By default full load is selected.',
    details: [
        // Incremental load requirements
        'If you want to perform incremental load:',
        'You should have a field to identify deletes in your data.',
        'You should have a field to identify the record created datetime.',
        'You should have a field to identify the record modified datetime, else choose full load.',

        // SCD Types
        'SCD Types in full load:',
        'SCD Type 1: Overwrites existing dimension attributes without storing history.',
        'SCD Type 2: Adds new records to store historical changes.',
    ],
};